// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import OrderedListOutlinedSvg from "@fishx/icons-svg/es/asn/OrderedListOutlined";
import FishxIcon from '../components/FishxIcon';

var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: OrderedListOutlinedSvg
  }));
};

OrderedListOutlined.displayName = 'OrderedListOutlined';
export default React.forwardRef(OrderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/OrderedListOutlined.js
// module id = 3190
// module chunks = 0